import React from "react";
import { Box, Card, Skeleton, Stack } from "@mui/material";

const LoadingAgentCard = () => {
  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: 3,
        border: "1px solid",
        borderColor: "border.lightest",
        overflow: "hidden",
        boxShadow: "none",
        bgcolor: "white",
      }}
    >
      <Stack padding={2}>
        {/* Header Section */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Skeleton variant="circular" width={45} height={45} sx={{ mr: 2 }} />{" "}
          {/* Avatar Skeleton */}
          <Box>
            <Skeleton variant="text" width={150} height={22} sx={{ mb: 0.1 }} />{" "}
            {/* Name Skeleton */}
            <Skeleton variant="text" width={100} height={22} />{" "}
          </Box>
        </Box>
        {/* Rating Section */}
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 0.5 }}>
          <Skeleton
            variant="rectangular"
            width={25}
            height={24}
            sx={{ borderRadius: 0.5 }}
          />{" "}
          {/* Star Icon Skeleton */}
          <Skeleton variant="text" width={120} height={35} />
        </Stack>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={1}
          sx={{ bgcolor: "border.lightest", mb: 1.5 }}
        />{" "}
        {/* Divider Skeleton */}
        {/* Specialties Section */}
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="text" width={80} height={20} sx={{ mb: 0.5 }} />{" "}
          {/* Label Skeleton */}
          <Skeleton variant="text" width="90%" height={24} />{" "}
          {/* Content Skeleton */}
        </Box>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={1}
          sx={{ bgcolor: "border.lightest", mb: 1.5 }}
        />{" "}
        {/* Divider Skeleton */}
        {/* Location Section */}
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="text" width={60} height={20} sx={{ mb: 0.5 }} />{" "}
          {/* Label Skeleton */}
          <Skeleton variant="text" width="100%" height={24} />{" "}
          {/* Content Skeleton (can be multiple lines) */}
        </Box>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={1}
          sx={{ bgcolor: "border.lightest", mb: 1 }}
        />{" "}
        {/* Divider Skeleton */}
        {/* Action Buttons */}
        <Stack
          width={"100%"}
          direction="row"
          justifyContent={"space-between"}
          spacing={1.5}
        >
          <Skeleton
            variant="rectangular"
            width="85%"
            height={38}
            sx={{ borderRadius: 8 }}
          />{" "}
          {/* Send Message Button Skeleton */}
          <Skeleton
            variant="rectangular"
            width={48}
            height={38}
            sx={{ borderRadius: 2 }}
          />{" "}
          {/* Phone Icon Button Skeleton */}
        </Stack>
      </Stack>
    </Card>
  );
};

export default LoadingAgentCard;
